import { PERMISSION_MAP } from '../constants/routes';

// The app's default landing / "home" page per role.
//
// Seller (role 2) and seller+warehouse (role 5) accounts land on the dashboard; every other role
// keeps the SKU list. Accepts a user object using either `role.id` or the flat `role_id`, so it
// works from any of the redirect sites (App.js, login, onboarding, the logo/home buttons).
//
// Employees inherit the seller's role (2/5) but only hold a SUBSET of permissions. The dashboard
// route is permission-gated ('dashboard'), so ProtectedRoute bounces an employee without that
// permission to /access-denied. To avoid stranding them, only send an employee to the dashboard
// when they actually hold the 'dashboard' permission; otherwise keep the prior SKU-list default.
export const getDefaultLandingPath = (user) => {
  const roleId = Number(user?.role?.id ?? user?.role_id);
  const isSellerRole = roleId === 2 || roleId === 5;
  if (!isSellerRole) return '/inventory/sku';

  if (user?.is_employee_of) {
    const permissionNames = (user?.permissions || []).map((id) => PERMISSION_MAP[id]);
    return permissionNames.includes('dashboard') ? '/dashboard' : '/inventory/sku';
  }

  return '/dashboard';
};

export default getDefaultLandingPath;
